import { onApiError } from "../error"
import { state } from "../state"
import { get } from "./client"

async function refreshToken() {
    if (!await state.isSignedIn()) return

    const res = await get("/token")

    if (res.ok) {
        await state.setToken(await res.json())
        return
    }

    switch (res.status) {
        case 401:
            state.signOut()
            return
        default:
            throw await onApiError(res)
    }
}

export {
    refreshToken
}